/**
 * Approximate opacity of a fine wire mesh.
 * @module
 */
import { safeShaderReplace, type ShaderProgramLike } from "../shaderUtils";
import { hash21Declaration } from "./utils";

export const METAL_SCREEN_OPACITY_DISTANCE = 100.0;

export function includeMetalScreenOpacity(shader: ShaderProgramLike) {
  const formattedMetalScreenOpacityDistance = METAL_SCREEN_OPACITY_DISTANCE.toFixed(1);

  shader.fragmentShader = safeShaderReplace(
    shader.fragmentShader,
    "#include <common>",
    `#include <common>
      ${hash21Declaration}
      float metalScreenBlendingRandomFactor;

      uniform float sampleIndex;

      bool useMetalScreenFineMesh(float viewDist) {
        return viewDist < ${formattedMetalScreenOpacityDistance} * (1.0 + float(sampleIndex) * 0.1) + metalScreenBlendingRandomFactor;
      }
    `,
    "includeMetalScreenOpacity (common)",
  );
  shader.fragmentShader = safeShaderReplace(
    shader.fragmentShader,
    "#include <tonemapping_fragment>",
    `
      if (!useMetalScreenFineMesh(viewDist)) {
        float opacityMul = min(1.18 - metalScreenNdotV * 0.58, 1.0);
        gl_FragColor.a = opacityMul * diffuseColor.a;
      }
      #include <tonemapping_fragment>
      `,
    "includeMetalScreenOpacity (tonemapping_fragment)",
  );
}
